export const DETAIL_MANUAL_PRODUCT_HEADER = [
  {
    id: 0,
    label: 'IDivision',
  },
  {
    id: 1,
    label: 'IAnalysisIndicatorsV1',
  },
]

export const PREPAID_MANUAL_PRODUCT_HEADER = [
  {
    id: 2,
    label: 'IPaidPoints',
  },
]

export const MOCK_DATA = [
  {
    id: 0,
    cls: 'EEG',
    analysis: '뇌 기능 매핑',
    point: 1000,
    deductions: 1,
  },
  {
    id: 1,
    cls: 'EEG',
    analysis: '뇌 기능 5대 지표',
    point: 1000,
    deductions: 1,
  },
  {
    id: 2,
    cls: 'MCI',
    analysis: 'MCI',
    point: 1000,
    deductions: 1,
  },
  {
    id: 3,
    cls: 'HRV',
    analysis: 'HRV 요약지 - 기본',
    point: 1000,
    deductions: 1,
  },
  {
    id: 4,
    cls: 'PBM',
    analysis: 'PBM CARE',
    point: 1000,
    deductions: 1,
  },
]
